import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import imglogo from "../asstes/addicon.png";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import FolderImg1 from "../../src/asstes/FolderIcon.png";
import FolderImg2 from "../../src/asstes/FolderIcon.png";
import AddIcon from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import {
  DRCoreApi,
  FileLoader,
  UploadApi,
  keyImages,
} from "../constants/Constants";
import { useNavigate, useParams } from "react-router-dom";
import CustomizedSnackbars from "./CustomizedSnackbars";
import {
  createFolder,
  setLoader,
  setModalFolder,
  setbuttonTop,
  setFolderList,
  setFolderSearch,
  setFolderName,
} from "../app/features/counterSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import FolderIcon from "@mui/icons-material/Folder";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  OutlinedInput,
  TextField,
} from "@mui/material";
import axios from "axios";
import AlertDialogSlide3 from "./AlertDialogSlide3";
import { IoMdShare } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { SpaceContext } from "antd/lib/space";
import RightArrow from "../../src/asstes/RightArrow.png";
import LeftArrow from "../../src/asstes/LeftArrow.png";
import Home from "../../src/asstes/Home.png";
import checkBox from "../../src/asstes/checkBox.png";
import Folder from "../../src/asstes/Folder2.png";
import Loader from "./Loader";
import cogoToast from "cogo-toast";
import {
  AWS_Access_Key_Id,
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";
import NotificationsPage from "../pages/Notifications/NotificationPage";
const rows = [];

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Patient name",
  },
  {
    id: "mrn",
    numeric: false,
    disablePadding: false,
    label: "MRN",
  },
  {
    id: "Accession",
    numeric: false,
    disablePadding: false,
    label: "Accession",
  },
  {
    id: "Study Date",
    numeric: false,
    disablePadding: false,
    label: "Study Date",
  },
  {
    id: "modality",
    numeric: false,
    disablePadding: false,
    label: "Modality",
  },
  {
    id: "bucket",
    numeric: false,
    disablePadding: true,
    label: "Bucket",
  },
];

const columns = [
  {
    label: "Patient Name",
    field: "name",
    sort: "asc",
    width: 150,
  },
  {
    label: "MRN",
    field: "mrn",
    sort: "asc",
    width: 100,
  },
  {
    label: "Accession",
    field: "Accession",
    sort: "asc",
    width: 100,
  },
  {
    label: "Study Date",
    field: "Study Date",
    sort: "asc",
    width: 100,
  },
  {
    label: "Modality",
    field: "modality",
    sort: "asc",
    width: 100,
  },
  {
    label: "Bucket",
    field: "bucket",
    sort: "asc",
    width: 100,
  },
  {
    label: "Actions",
    field: "action",
    sort: "asc",
    width: 70,
  },
];

function EnhancedTableHead(props) {
  const {
    // onSelectAllClick,
    order,
    orderBy,
    // numSelected,
    // rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <b>{headCell.label}</b>
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <>
      <Typography
        sx={{ flex: "1 1 100%" }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Study List
      </Typography>
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Tooltip title="Delete" placement="top">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          ""
        )}
      </Toolbar>
    </>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable({
  setTab,
  // setPassword,
}) {
  const [openFolder, setOpenFolder] = React.useState(false);
  const [createfoler, setCreteFolder] = React.useState([]);
  const [emailValue, setEmailValue] = React.useState(null);
  const [descriptValue, setDescriptValue] = React.useState([]);
  const navigate = useNavigate();
  const { FolderName } = useParams();
  const FolderSearch = useSelector((state) => state.folderSearch);
  const modalFolder = useSelector((state) => state.modalFolder);
  const [cOpen1, setCOpen1] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  const FolderList = useSelector((state) => state.FolderList);
  //console.log(FolderList, FolderGet, "OokokokokokFolderList");
  const [isOpen, setIsOpen] = React.useState(false);
  const [severity, setSeverty] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [hoveredFolder, setHoveredFolder] = React.useState(null);
  const [EditModal, setEditModal] = React.useState(false);
  const [EditValue, setEditValue] = React.useState("");
  const [oldKey, setOldKey] = React.useState("");
  const dispatch = useDispatch();
  const [loader, setLoader] = React.useState(false);
  const [folderList, setFOLDERLIST] = React.useState([]);
  const [ErrorMassage, setErrorMassage] = React.useState("");
  const [subfoldersHave, setSubfolderHave] = React.useState(false);
  const [studiesHave, setStudiesHave] = React.useState(false);
  const RefreshLoader = useSelector((state) => state.RefreshLoader);
  const [deleteName, setDeleteName] = React.useState("");
  const [random, setRandom] = React.useState(false);
  const state = useSelector((state) => state.user);
  const canShare = useSelector((state) => state.canShare);
  const [showNotifications, setShowNotifications] = React.useState(false);
  // //console.log(RefreshLoader,"RefreshLoaderRefreshLoader");

  const saveStudyData = (FolderName) => {
    // dispatch(setbuttonTop(false));
    navigate(`/SubFolder&studies/${FolderName}`);
    // localStorage.setItem("folderName",modality);
    // //console.log(modality,"modalitumodalitumodalitu");
    setTab(4);
  };

  React.useEffect(() => {
    dispatch(setbuttonTop(false));
  }, []);

  // ==== Share Data hyperledge===

  const convertDate = (inputDate) => {
    // Extract year, month, and day from the inputDate string
    const year = inputDate.substring(0, 4);
    const month = inputDate.substring(4, 6);
    const day = inputDate.substring(6, 8);

    // Concatenate the year, month, and day in the US date format
    const usDate = `${day}/${month}/${year}`;

    return usDate;
  };

  // let formationOfData = []
  const fetchStudies = async (name) => {
    // setLoader(true);
    const formationOfData = [];
    let token = localStorage.getItem("token");
    // if (!token) {
    //   token =
    //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY1YWI2MjhkNDdlZGQwZmQ0MjMyZjhmNSIsImlhdCI6MTcwNjYxOTI2NCwiZXhwIjoxNzM4MTU1MjY0fQ.IPPNUyR0I9ZnJ9IQfQPOBU3F-ZSteMEkJLpSw9WmDII";
    //   localStorage.setItem("token", token);
    // }
    // const formatedData = []
    try {
      const formData = new FormData();
      formData.append("folderName", `${name}`);
      formData.append("bucketName", AWS_Bucket_Name());
     
      formData.append("Region", AWS_Region());

      const hello = await fetch(`${UploadApi}/apiUpload/GetData`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const resp = await hello.json();
      // //console.log(resp, "wwwww2");

      if (resp?.success) {
        setStudiesHave(false);
        setRandom(!random);
        setDeleteName(`${name}`);
      } else {
        setRandom(!random);
        setStudiesHave(true);
      }
      setDeleteName(`${name}`);
      // setLoader(false);
    } catch (error) {
      console.log(error);
      // setLoader(false);
    }
  };

  const createFolder = async () => {
    const specialCharPattern = /[^a-zA-Z0-9._-\s]/;
    setLoader(true);
    setOpenFolder(false);
    dispatch(setModalFolder(false));
    setCreteFolder([...createfoler, { name: emailValue }]);
    if (!emailValue || /^\s*$/.test(emailValue)) {
      cogoToast.error("Folder name cannot be empty", {
        position: "top-right",
        hideAfter: 5,
      });
      setLoader(false);
      dispatch(setModalFolder(true));
    } else if (sortedFolderList.includes(emailValue.trim())) {
      cogoToast.warn("Folder Already Exists", {
        position: "top-right",
        hideAfter: 5,
      });
      setLoader(false);
      dispatch(setModalFolder(true));
      return;
    } else if (emailValue.length > 200) {
      // alert("Folder Name must be less than 25 letters");
      // setLoader(false);
      setErrorMassage("Folder Name must be less than 25 letters");
      dispatch(setModalFolder(true));
    } else if (specialCharPattern.test(emailValue)) {
      cogoToast.error("Sorry, the use of special symbols is not allowed.", {
        position: "top-right",
        hideAfter: 5,
      });
      setLoader(false);
      dispatch(setModalFolder(true));
    } else {
      try {
        const token = localStorage.getItem("token");
        const formData = new FormData();
        formData.append("awsbucketname", AWS_Bucket_Name());
        formData.append("awsAccessKeyId", AWS_Access_Key_Id_Encypt());
        formData.append("awsSecretAccessKey", AWS_Secret_Access_Key_Encypt());
        formData.append("Region", AWS_Region());
        formData.append(
          "DCMCAccessKey",
          process.env.React_App_User_DCMC_Access_Key_encypt
        );
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        };

        let newEmailValue = emailValue;
        let sanitizedFolderName = "";

        if (canShare) {
          if (typeof FolderGet === "string") {
            sanitizedFolderName = FolderGet;
          } else if (Array.isArray(FolderGet)) {
            sanitizedFolderName = FolderGet.join(",");
          }
          newEmailValue = `${emailValue}--ONLYSHARE--${sanitizedFolderName.replaceAll(
            "/",
            "--SLASH--"
          )}`;
        }

        let res = await axios.post(
          `${FileLoader}/fileloaderv1/files/FolderCreate?UserAccessKey=WO0OZEHTOGFYN9Z6&UserSecretAccessKey=OYTZHWZY6TZTO0NFINK01IC4IEJL43BV&FolderName=${newEmailValue.trim()}&Location=${
            Intl.DateTimeFormat().resolvedOptions().timeZone
          }&Username=${state.email}`,
          formData,
          { headers }
        );

        if (res) {
          setLoader(false);
        }
        if (res.data?.CreationTime) {
          setErrorMassage("");
          setIsOpen(true);
          setMessage("Folder Created Successfully");
          setSeverty("success");
          setTimeout(() => {
            setIsOpen(false);
          }, 3000);
        } else {
          cogoToast.warn("Folder Already Exists", {
            position: "top-right",
            hideAfter: 5,
          });
        }

        // Fetch studies after creating the folder
        // await fetchStudies();
        await GetFolderListApi();
      } catch (error) {
        console.error("Error:", error);
        setIsOpen(true);
        setMessage("Failed to created Folder");
        setSeverty("error");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
        setLoader(false);
      }
    }
  };

  const getOnlyShareFolders = async (sharedFolders) => {
    try {
      const data = {
        folderName: sharedFolders,
        bucketName: AWS_Bucket_Name(),
       
        Region: AWS_Region(),
      };

      const response = await axios.post(
        `${UploadApi}/apiUpload/only-share`,
        data
      );

      if (response.data) {
        const filteredData = response.data.map((item) => item);
        return filteredData;
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const GetFolderListApi = async () => {
    setLoader(true);
    dispatch(setFolderList([]));
    dispatch(setFolderSearch([]));
    const token = localStorage.getItem("token");
    if (FolderGet) {
      //console.log(typeof FolderGet, "Folder Get type");
      if (typeof FolderGet == "string") {
        const onlySharedFolders = canShare
          ? await getOnlyShareFolders(FolderGet)
          : [];
        setFOLDERLIST([FolderGet, ...onlySharedFolders]);
        setLoader(false);
      } else {
        const onlySharedFolders = canShare
          ? await getOnlyShareFolders(FolderGet.join(","))
          : [];
        setFOLDERLIST([...FolderGet, ...onlySharedFolders]);
        setLoader(false);
      }
    } else {
      try {
        const response = await fetch(
          `${FileLoader}/fileloaderv1/files/GetFolderList/?awsAccessKeyId=${encodeURIComponent(
            AWS_Access_Key_Id_Encypt()
          )}&awsSecretAccessKey=${encodeURIComponent(
            AWS_Secret_Access_Key_Encypt()
          )}&bucketName=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 401) {
          localStorage.removeItem("token");
          navigate("/signin");
        }

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        if (response) {
          setLoader(false);
        }
        const GetFolderList = await response.json();
        // //console.log("Folder List:", GetFolderList);
        setFOLDERLIST(GetFolderList);
        dispatch(setFolderList(GetFolderList));
        // Process folderList data as needed
        // Set state or perform any other actions with the folder data
      } catch (error) {
        console.error("Error fetching folder data:", error);
        setLoader(false);
      }
    }
  };

  React.useEffect(() => {
    // fetchStudies();
    GetFolderListApi();
  }, [RefreshLoader]);

  React.useEffect(() => {
    if (FolderList.length !== 0) {
      // //console.log("Ookokokokok condition");
      // setFOLDERLIST([FolderList]);
      setsortedFolderList(FolderList);
    } else {
      setsortedFolderList(
        folderList.slice().sort((a, b) => a.localeCompare(b))
      );
    }
  }, [FolderList, folderList]);

  const deleteNow = async (name) => {
    setLoader(true);
    try {
      let token = localStorage.getItem("token");

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let formData = {
        AwsBucket: AWS_Bucket_Name(),
        FolderName: `${name}/`,
        UserName: state.email,
      };

      let response = await axios.post(
        // "http://localhost:8001/keyImages/v1/updateFolder/moveToArchive",
        // "https://app.dcmcloud.com/keyImages/v1/updateFolder/deleteFolder",
        `${keyImages}/keyImages/v1/updateFolder/moveToArchive`,
        JSON.stringify(formData),
        { headers }
      );

      if (response) {
        const updatedFolderList = sortedFolderList.filter(
          (folder) => folder !== deleteName
        );
        //console.log(updatedFolderList, "updatedFolderListupdatedFolderList");
        // Update the state with the filtered list
        //         dispatch(setFolderList(updatedFolderList));
        // setsortedFolderList(updatedFolderList)
        //console.log("Folder deleted successfully:", response);
        setIsOpen(true);
        setMessage("Folder delete Successfully");
        setSeverty("error");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
        setLoader(false);

        // await fetchStudies();
        await GetFolderListApi();
      }
    } catch (error) {
      cogoToast.error("Failed to delete folder", {
        position: "top-right",
        hideAfter: 5,
      });
      console.error("Error while deleting folder:", error);
      setLoader(false);
    }
  };

  // React.useEffect(() => {
  //   if (deleteName) {
  //     if (subfoldersHave && studiesHave) {
  //       deleteNow();
  //     } else {
  //       alert(`You need to delete data first from " ${deleteName} "`);
  //       setLoader(false);
  //     }
  //   }
  // }, [subfoldersHave, studiesHave, random]);

  const [sortedFolderList, setsortedFolderList] = React.useState(
    folderList.slice().sort((a, b) => a.localeCompare(b))
  );

  const DeleteFolder = async (name) => {
    deleteNow(name);
  };

  const EditedFolder = async (name) => {
    const specialCharPattern = /[^a-zA-Z0-9._-\s]/;
    // Check if emailValue contains any special characters
    if (specialCharPattern.test(EditValue)) {
      cogoToast.error("Sorry, the use of special symbols is not allowed.", {
        position: "top-right",
        hideAfter: 5,
      });
      return;
    }
    if (!EditValue.trim()) {
      cogoToast.error("Folder name cannot be empty", {
        position: "top-right",
        hideAfter: 5,
      });
      console.error("Folder name cannot be empty");
      return;
    }
    if (sortedFolderList.includes(EditValue)) {
      //console.log(sortedFolderList, "aaaaaqqq");
      cogoToast.error("Folder name already exist", {
        position: "top-right",
        hideAfter: 5,
      });
      console.error("Folder name already exist");
      return;
    }
    setLoader(true);
    setEditModal(false);
    try {
      let token = localStorage.getItem("token");

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let formData = {
        AwsBucket: AWS_Bucket_Name(),
        oldKey: oldKey + "/",
        newKey: oldKey.includes("--ONLYSHARE--")
          ? EditValue + "--ONLYSHARE--" + oldKey.split("--ONLYSHARE--")[1] + "/"
          : EditValue + "/",
      };

      let response = await axios.post(
        `${keyImages}/keyImages/v1/updateFolder/updateFolder`,
        JSON.stringify(formData),
        { headers }
      );

      if (response) {
        setEditModal(false);
        setIsOpen(true);
        setMessage("Folder Updated Successfully");
        setSeverty("success");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
        setLoader(false);
        // await fetchStudies();
        await GetFolderListApi();
      }
    } catch (error) {
      setEditModal(false);
      setLoader(false);
    }
  };

  // const sortedFolderList = folderList
  //   .slice()
  //   .sort((a, b) => a.localeCompare(b)); //sorted the elements according to their alphabatical orders

  return (
    <>
      {/* Create Folder */}

      <div style={{ background: "rgba(0, 0, 0, 0.12)", marginTop: "-10px" }}>
        <Dialog
          open={modalFolder}
          onClose={() => dispatch(setModalFolder(false))}
          // style={{ height: "70%" }}
          PaperProps={{
            style: {
              height: "200px",
            },
          }}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ margin: "auto", color: "#1976D2" }}>
            {"Create Folder"}
          </DialogTitle>
          <DialogContent style={{ overflowX: "hidden", marginLeft: 5 }}>
            <DialogContentText id="alert-dialog-slide-description">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                  <Grid item lg={12} style={{ paddingLeft: 23 }}>
                    <br />
                    <TextField
                      onChange={(e) => {
                        setEmailValue(e.target.value);
                        setErrorMassage("");
                      }}
                      autoFocus
                      hiddenLabel
                      required
                      label="Folder Name"
                      variant="outlined"
                      size="small"
                      type={"text"}
                      style={{
                        borderRadius: "3px",
                        backgroundColor: "white",
                        width: 538,
                        marginTop: "5px",
                      }}
                    />
                    {ErrorMassage && (
                      <p className="text-red-600">{ErrorMassage}</p>
                    )}
                  </Grid>
                </Grid>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
            <Button
              onClick={() => {
                dispatch(setModalFolder(false));
                setLoader(false);
                setErrorMassage("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                createFolder();
                // setLoader(false);
              }}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {/* Edit Folder Modal */}

      <div style={{ background: "rgba(0, 0, 0, 0.12)", marginTop: "-10px" }}>
        <Dialog
          open={EditModal}
          // style={{ height: "70%" }}
          PaperProps={{
            style: {
              height: "250px",
            },
          }}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ margin: "auto", color: "#1976D2" }}>
            {"Edit "}
          </DialogTitle>
          <DialogContent style={{ overflowX: "hidden", marginLeft: 5 }}>
            <DialogContentText id="alert-dialog-slide-description">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                  <Grid item lg={12} style={{ paddingLeft: 23 }}>
                    <br />
                    <span>
                      *Editing the folder name will expire the shared links.
                      Please re-share the links.
                    </span>
                    <TextField
                      onChange={(e) => setEditValue(e.target.value)}
                      autoFocus
                      hiddenLabel
                      required
                      label="Folder Name"
                      variant="outlined"
                      size="small"
                      value={EditValue}
                      type={"text"}
                      style={{
                        borderRadius: "3px",
                        backgroundColor: "white",
                        width: 538,
                        marginTop: "10px",
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
            <Button onClick={() => setEditModal(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                EditedFolder();
                // createFolder();
                // setLoader(false);
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div className="flex justify-center w-full ">
        <div className="flex flex-col justify-center items-center w-full ">
          <div
            className="flex flex-col md:flex-row flex-wrap justify-center items-left w-full"
            style={{
              height: `${"auto"}`,
              marginTop: `${"0"}`,
            }}
          >
            {/* Sub Navbar */}
            <div className="flex w-full text-xs md:test-sm text-purple-800 bg-white border h-12 rounded-xl mb-4 shadow-md">
              <div className="inline-flex w-full h-full items-center">
                <div
                  className="flex cursor-pointer"
                  onClick={() => {
                    if (window.location.href.includes("SubFolder&studies")) {
                      setTab(5);
                      navigate("/");
                    }
                  }}
                >
                  {" "}
                  <img
                    src={LeftArrow}
                    className="mx-3"
                    height="20px"
                    width="20px"
                    alt="img"
                  />
                </div>

                <div className="flex cursor-pointer font-bold items-center">
                  {" "}
                  <img
                    src={Folder}
                    className="mx-2"
                    height="20px"
                    width="20px"
                    alt="img"
                  />
                  My Folders
                </div>
              </div>
              {/* <div className="flex w-full float-right ">
                <div className="flex cursor-pointer font-bold mx-3">
                  {" "}
                  <img
                    src={checkBox}
                    className="mx-2"
                    height="20px"
                    width="20px"
                    alt="img"
                  />
                  My Folders
                </div>
                <div className="flex cursor-pointer font-bold">
                  {" "}
                  <img
                    src={checkBox}
                    className="mx-2"
                    height="20px"
                    width="20px"
                    alt="img"
                  />
                  Shared With Me
                </div>
                <div className="flex cursor-pointer font-bold">
                  {" "}
                  <img
                    src={checkBox}
                    className="mx-2"
                    height="20px"
                    width="20px"
                    alt="img"
                  />
                  Shared With My Groups
                </div>
              </div> */}
            </div>

            <Box className="w-full">
              {loader ? (
                <div className="w-full my-20">
                  {" "}
                  <Loader />
                </div>
              ) : FolderSearch?.length !== 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-9 gap-x-3 justify-items-center justify-center">
                  {FolderSearch?.length !== 0 &&
                    FolderSearch?.map(
                      (item) =>
                        item != "archive" &&
                        item != "Multi" && (
                          <Tooltip
                            title={
                              canShare || item.includes("--ONLYSHARE--")
                                ? item.split("--ONLYSHARE--")[0]
                                : item
                            }
                          >
                            <Card
                              className="admin-card w-full mb-3"
                              key={item.clientHandler}
                            >
                              <div
                                className="admin-card-contnet"
                                style={{
                                  display: "flex",
                                  position: "relative",
                                  flexDirection: "column",
                                }}
                              >
                                {/* {//console.log("Data is running", item)} */}
                                <CardContent className="px-2 py-3">
                                  <div
                                    className="w-[100px] m-auto mb-2"
                                    // style={{
                                    //   display: "flex",
                                    //   alignItems: "center",
                                    //   justifyContent: "center",
                                    //   position: "relative",
                                    //   overflow: "hidden",
                                    //   // width: "250px",
                                    //   //  to control the container
                                    // }}
                                    onClick={() => saveStudyData(item)}
                                    onMouseEnter={() => setHoveredFolder(item)}
                                    onMouseLeave={() => setHoveredFolder(null)}
                                  >
                                    <img
                                      className="imgLabs"
                                      src={
                                        hoveredFolder === item
                                          ? FolderImg2
                                          : FolderImg1
                                      }
                                      alt="Your Image"
                                      style={{
                                        // width: "100px",
                                        // height: "125px",
                                        // marginBottom: "20px",
                                        transition: "transform 0.3s ease",
                                        transform:
                                          hoveredFolder === item
                                            ? "scale(1.1)"
                                            : "scale(1)",
                                        filter:
                                          hoveredFolder === item
                                            ? "none"
                                            : "none",
                                      }}
                                    />
                                  </div>
                                  <div className="flex flex-col items-center text-center">
                                    {/* style={{
                                      // textAlign: "center",
                                      margin: "20px",
                                      marginLeft: "30px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      position: "absolute",
                                      padding: "10px",
                                      top: "85%",
                                      left: "40%",
                                      // width: "500px",
                                      transform: "translate(-50%, -50%)",
                                    }}
                                  > */}
                                    {/* <span>{item.split(" ").slice(2).join(" ")}</span> */}
                                    {/* <span
                                      style={{
                                        padding: "50px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      className="flex "
                                    > */}
                                    {/* {item.split(" ").slice(0, 2).join(" ")} */}
                                    <span
                                      className="w-full text-sm overflow-hidden font-medium FontFamilyGilroy"
                                      style={{
                                        // padding: "50px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {canShare ||
                                      item.includes("--ONLYSHARE--")
                                        ? item.split("--ONLYSHARE--")[0]
                                        : item}
                                    </span>
                                    {!FolderGet && (
                                      <span
                                        // style={{cursor:"pointer"}}
                                        className="m-1 flex  cursor-pointer float-right"
                                      >
                                        {/* Share button */}
                                        <Tooltip
                                          title="Share"
                                          placement="top"
                                          onClick={() => {
                                            setCOpen1(true);
                                            setEmail(item);
                                          }}
                                        >
                                          <IoMdShare className="h-5 w-5" />{" "}
                                        </Tooltip>
                                        {/* <Tooltip title="Notification"
                                          placement="top">
                                          <div onClick={() => {
                                            setTab(8);
                                            dispatch(setFolderName(item))
                                          }}>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="#000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              className="lucide lucide-bell-dot cursor-pointer"
                                            >
                                              <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                                              <path d="M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665" />
                                              <circle cx="18" cy="8" r="3"
                                              />
                                            </svg>
                                          </div>

                                        </Tooltip> */}
                                        {/* Edit Button */}
                                        <Tooltip
                                          title="Edit"
                                          placement="top"
                                          onClick={() => {
                                            setEditModal(true);
                                            if (
                                              item.includes("--ONLYSHARE--")
                                            ) {
                                              setEditValue(
                                                item.split("--ONLYSHARE--")[0]
                                              );
                                            } else {
                                              setEditValue(item);
                                            }
                                            setOldKey(item);
                                          }}
                                        >
                                          <MdEdit className="h-5 w-5 text-gray-700" />{" "}
                                        </Tooltip>

                                        {/* Delete Button */}
                                        <Tooltip
                                          title="Delete"
                                          placement="top"
                                          onClick={() => DeleteFolder(item)}
                                        >
                                          <MdDelete className="h-5 w-5 text-gray-700" />{" "}
                                        </Tooltip>
                                      </span>
                                    )}
                                    {/* </span> */}
                                  </div>
                                </CardContent>
                              </div>
                            </Card>
                          </Tooltip>
                        )
                    )}

                  {/* <AlertDialogSlide3
                  cOpen={cOpen1}
                  setCOpen={setCOpen1}
                  email={email}

                  // cpass={cPass}
                  // cAccession={cAccession}
                /> */}
                  <AlertDialogSlide3
                    cOpen={cOpen1}
                    setCOpen={setCOpen1}
                    email={email}
                    // cpass={cPass}
                    // cAccession={cAccession}
                  />
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-9 gap-x-3 justify-items-center justify-center">
                  {/* new work */}
                  {sortedFolderList?.length !== 0 &&
                    sortedFolderList?.map(
                      (item) =>
                        item != "archive" &&
                        item != "Multi" && (
                          <Tooltip
                            title={
                              item.includes("--ONLYSHARE--")
                                ? item.split("--ONLYSHARE--")[0]
                                : FolderGet && item.includes("/")
                                ? item.split("/")[item.split("/").length - 1]
                                : item
                            }
                          >
                            <Card
                              className="admin-card w-full mb-3"
                              key={item.clientHandler}
                            >
                              <div
                                className="admin-card-contnet"
                                style={{
                                  display: "flex",
                                  position: "relative",
                                  flexDirection: "column",
                                }}
                              >
                                {/* {//console.log("Data is running", item)} */}
                                <CardContent className="px-2 py-3">
                                  <div
                                    className="w-[100px] m-auto mb-2"
                                    style={
                                      {
                                        // display: "flex",
                                        // alignItems: "center",
                                        // justifyContent: "center",
                                        // position: "relative",
                                        // overflow: "hidden",
                                        // width: "250px",
                                        //  to control the container
                                      }
                                    }
                                    onClick={() => saveStudyData(item)}
                                    onMouseEnter={() => setHoveredFolder(item)}
                                    onMouseLeave={() => setHoveredFolder(null)}
                                  >
                                    <img
                                      className="imgLabs"
                                      src={
                                        hoveredFolder === item
                                          ? FolderImg2
                                          : FolderImg1
                                      }
                                      alt="Your Image"
                                      style={{
                                        // width: "150px",
                                        // height: "125px",
                                        // marginBottom: "20px",
                                        transition: "transform 0.3s ease",
                                        transform:
                                          hoveredFolder === item
                                            ? "scale(1.1)"
                                            : "scale(1)",
                                        filter:
                                          hoveredFolder === item
                                            ? "none"
                                            : "none",
                                      }}
                                    />
                                  </div>
                                  <div className="flex flex-col items-center text-center">
                                    {/* <span>{item.split(" ").slice(2).join(" ")}</span> */}
                                    {/* <span
                                      style={{
                                        // padding: "50px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      className="flex "
                                    > */}
                                    {/* {item.split(" ").slice(0, 2).join(" ")} */}
                                    <span
                                      className="w-full text-sm overflow-hidden font-medium FontFamilyGilroy"
                                      style={{
                                        // padding: "50px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {item.includes("--ONLYSHARE--")
                                        ? item.split("--ONLYSHARE--")[0]
                                        : FolderGet && item.includes("/")
                                        ? item.split("/")[
                                            item.split("/").length - 1
                                          ]
                                        : item}
                                    </span>
                                    <span
                                      // style={{cursor:"pointer"}}
                                      className="m-1 flex  cursor-pointer float-right"
                                    >
                                      {/* Share button */}
                                      {!FolderGet || canShare ? (
                                        <Tooltip
                                          title="Share"
                                          placement="top"
                                          onClick={() => {
                                            setCOpen1(true);
                                            setEmail(item);
                                          }}
                                        >
                                          <IoMdShare className="h-5 w-5" />{" "}
                                        </Tooltip>
                                      ) : (
                                        ""
                                      )}

                                      {/* <Tooltip title="Notification"
                                          placement="top">
                                          <div onClick={() => {
                                            setTab(8);
                                            dispatch(setFolderName(item))
                                          }}>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="#000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                              className="lucide lucide-bell-dot cursor-pointer"
                                            >
                                              <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                                              <path d="M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665" />
                                              <circle cx="18" cy="8" r="3" />
                                            </svg>
                                          </div>

                                        </Tooltip> */}
                                      {/* Edit Button */}
                                      {!FolderGet ||
                                      (canShare &&
                                        item.includes("--ONLYSHARE--")) ? (
                                        <Tooltip
                                          title="Edit"
                                          placement="top"
                                          onClick={() => {
                                            setEditModal(true);
                                            if (
                                              item.includes("--ONLYSHARE--")
                                            ) {
                                              setEditValue(
                                                item.split("--ONLYSHARE--")[0]
                                              );
                                            } else {
                                              setEditValue(item);
                                            }
                                            setOldKey(item);
                                          }}
                                        >
                                          <MdEdit className="h-5 w-5 text-gray-700" />{" "}
                                        </Tooltip>
                                      ) : (
                                        ""
                                      )}

                                      {/* Delete Button */}
                                      {!FolderGet && (
                                        <Tooltip
                                          title="Delete"
                                          placement="top"
                                          onClick={() => DeleteFolder(item)}
                                        >
                                          <MdDelete className="h-5 w-5 text-gray-700" />{" "}
                                        </Tooltip>
                                      )}
                                    </span>
                                    {/* </span> */}
                                  </div>
                                </CardContent>
                              </div>
                            </Card>
                          </Tooltip>
                        )
                    )}
                  {/* <AlertDialogSlide3
                    cOpen={cOpen1}
                    setCOpen={setCOpen1}
                    email={email}

                    // cpass={cPass}
                    // cAccession={cAccession}
                  /> */}
                  <AlertDialogSlide3
                    cOpen={cOpen1}
                    setCOpen={setCOpen1}
                    email={email}
                    // cpass={cPass}
                    // cAccession={cAccession}
                  />
                </div>
              )}
            </Box>
          </div>
        </div>
      </div>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
}
